import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/no-data.png'


const _hoisted_1 = {
  key: 0,
  class: "leads-container"
}
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header align--flex-start ma--bottom-0" }
const _hoisted_9 = { class: "display--flex pa--bottom-1 align--center" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart btn--icon__prefix" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Purchase", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"1em"} }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart btn--icon__prefix" }, null, -1)
const _hoisted_16 = { class: "btn--name" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"1em"} }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check btn--icon__prefix" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "btn--name"
}
const _hoisted_20 = {
  key: 1,
  class: "btn--name"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"1em"} }, null, -1)
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-export btn--icon__prefix" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Export IP", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "pa--left-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Selected Leads:", -1)
const _hoisted_28 = { style: {"font-size":"80%"} }
const _hoisted_29 = {
  key: 0,
  style: {"padding-bottom":"8px"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("strong", null, "State: ", -1)
const _hoisted_31 = {
  key: 1,
  style: {"padding-bottom":"8px"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "Zipcodes: ", -1)
const _hoisted_33 = { key: 2 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "Date Range: ", -1)
const _hoisted_35 = { class: "dropdown display--flex justify--flex-end" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-filter btn--icon__prefix" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Filter", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = { class: "form-field__checkboxlist" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h4", null, "By State", -1)
const _hoisted_43 = ["onUpdate:modelValue", "onChange", "id"]
const _hoisted_44 = ["for"]
const _hoisted_45 = { class: "form--field__select ma--top-1" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h4", null, "By Unique Date", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "col-6" }
const _hoisted_50 = { class: "form-field__checkboxlist" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h4", null, "By Zipcode", -1)
const _hoisted_52 = ["onUpdate:modelValue", "id"]
const _hoisted_53 = ["for"]
const _hoisted_54 = { class: "form--field__textarea ma--bottom-1" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h4", null, "Google search keywords", -1)
const _hoisted_56 = { style: {"text-align":"right"} }
const _hoisted_57 = { class: "card-content" }
const _hoisted_58 = {
  key: 0,
  class: "table table--striped"
}
const _hoisted_59 = {
  class: "text--align-left pa--left-2",
  style: {"width":"20%"}
}
const _hoisted_60 = ["checked", "disabled"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  style: {"width":"30%"}
}, " Unique Date ", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  style: {"width":"25%"}
}, "State", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("th", {
  class: "text--align-left",
  style: {"width":"25%"}
}, "Zipcode", -1)
const _hoisted_64 = { class: "text--align-left pa--left-2" }
const _hoisted_65 = ["checked", "value"]
const _hoisted_66 = { class: "text--align-left" }
const _hoisted_67 = { class: "text--align-left" }
const _hoisted_68 = { class: "text--align-left" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_71 = [
  _hoisted_70
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PurchaseLeads = _resolveComponent("PurchaseLeads")!
  const _component_AutoDataDelivery = _resolveComponent("AutoDataDelivery")!
  const _component_ActiveAutoDataSummary = _resolveComponent("ActiveAutoDataSummary")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.response)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.request._loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          class: _normalizeClass(!_ctx.selectedLeads.length ? 'btn btn--primary' : 'btn btn--green'),
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedPurchaseLeads && _ctx.clickedPurchaseLeads(...args))),
                          disabled: !_ctx.selectedLeads.length && !_ctx.isSelectAll
                        }, _hoisted_13, 10, _hoisted_10),
                        _hoisted_14,
                        _createElementVNode("button", {
                          class: _normalizeClass(!_ctx.autoLeadsAlreadyPresent ? 'btn btn--primary' : 'btn btn--green'),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.autoLeadConfirm()))
                        }, [
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.autoLeadsAlreadyPresent?'Active ':'') + "Auto Data", 1)
                        ], 2),
                        _hoisted_17,
                        _createElementVNode("button", {
                          class: _normalizeClass(!_ctx.isAllSelected ? 'btn btn--primary' : 'btn btn--primary'),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.isAllSelected ? _ctx.selectAllLeads() : _ctx.clearSelectedLeads()))
                        }, [
                          _hoisted_18,
                          (!_ctx.isAllSelected)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Select All"))
                            : _createCommentVNode("", true),
                          (_ctx.isAllSelected)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Clear"))
                            : _createCommentVNode("", true)
                        ], 2),
                        _hoisted_21,
                        (this.store.getters.isAdmin || this.store.getters.isSuperAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn--primary",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportRawIPCSV && _ctx.exportRawIPCSV(...args))),
                              disabled: !_ctx.selectedLeads.length && !_ctx.isSelectAll
                            }, _hoisted_25, 8, _hoisted_22))
                          : _createCommentVNode("", true),
                        (_ctx.selectedLeads.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _hoisted_27,
                              _createTextVNode(" " + _toDisplayString(_ctx.selectedLeads.length), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (_ctx.selectedStates)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _hoisted_30,
                            _createTextVNode(" " + _toDisplayString(_ctx.selectedStates), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedZipcodes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _hoisted_32,
                            _createTextVNode(" " + _toDisplayString(_ctx.selectedZipcodes), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedDateRange)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _hoisted_34,
                            _createTextVNode(" " + _toDisplayString(_ctx.selectedDateRange), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn--primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
                        }, _hoisted_38),
                        _createElementVNode("div", {
                          class: _normalizeClass(["dropdown-menu dropdown-menu__right overflow--hidden", { show: _ctx.showFilters }]),
                          style: {"width":"680px","max-height":"600px","padding":"0.5rem 1rem"}
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                                        onChange: ($event: any) => (_ctx.getZipCodes(item)),
                                        id: 'state-' + index
                                      }, null, 40, _hoisted_43), [
                                        [_vModelCheckbox, item.selected]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'state-' + index
                                      }, _toDisplayString(item.text) + " (" + _toDisplayString(_ctx.$filters.numberDisplay(item.value)) + " " + _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() +
                                _ctx.leadName.slice(1)) + "s)", 9, _hoisted_44)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.request.leadDate) = $event)),
                                  style: {"margin":"0","width":"100%"}
                                }, [
                                  _hoisted_47,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadDate, (item, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item,
                                      key: index
                                    }, _toDisplayString(item), 9, _hoisted_48))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.request.leadDate]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _hoisted_51,
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zipCodes, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                                        id: 'zip-' + index
                                      }, null, 8, _hoisted_52), [
                                        [_vModelCheckbox, item.selected]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'zip-' + index
                                      }, _toDisplayString(item.text) + " (" + _toDisplayString(_ctx.$filters.numberDisplay(item.value)) + " " + _toDisplayString(_ctx.leadName.charAt(0).toUpperCase() +
                                _ctx.leadName.slice(1)) + "s)", 9, _hoisted_53)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.googleSearchKeywords) = $event)),
                                  placeholder: "Enter up to 10 Google Keywords, separated by commas.",
                                  rows: "3",
                                  cols: "35",
                                  style: {"width":"100%"}
                                }, null, 512), [
                                  [_vModelText, _ctx.googleSearchKeywords]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn--primary ma-1 text--size-1",
                              style: {"width":"auto","display":"inline-block","padding-left":"1rem","padding-right":"1rem"},
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                            }, " Apply "),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn ma--y-1 text--size-1",
                              style: {"width":"auto","display":"inline-block","padding-left":"1rem","padding-right":"1rem"},
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                            }, " Clear All ")
                          ])
                        ], 2)
                      ])), [
                        [_directive_click_outside, _ctx.clickOutSideFilter]
                      ]),
                      (_ctx.response.pageInfo.totalResults)
                        ? (_openBlock(), _createBlock(_component_Pagination, {
                            key: 0,
                            totalResults: _ctx.response.pageInfo.totalResults,
                            totalPages: _ctx.response.pageInfo.totalPages,
                            showPage: _ctx.response.data.length,
                            page: _ctx.request.page,
                            onApplyPagination: _ctx.controlWithPagination
                          }, null, 8, ["totalResults", "totalPages", "showPage", "page", "onApplyPagination"]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.togglePurchaseModel)
                      ? (_openBlock(), _createBlock(_component_PurchaseLeads, {
                          key: 0,
                          selectedLeads: _ctx.leads,
                          leadRequest: _ctx.isSelectAll ? _ctx.request : null,
                          totalLeads: _ctx.response.pageInfo.totalResults,
                          siteId: _ctx.siteId,
                          purchaseType: "purchaseLead",
                          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeModel($event))),
                          onPurchase: _ctx.updatePurchaseModel
                        }, null, 8, ["selectedLeads", "leadRequest", "totalLeads", "siteId", "onPurchase"]))
                      : _createCommentVNode("", true),
                    (_ctx.toggleAutoDataDeliveryModel)
                      ? (_openBlock(), _createBlock(_component_AutoDataDelivery, {
                          key: 1,
                          isEdit: _ctx.isEditAutoData,
                          editType: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.type:null,
                          editStatus: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.status:null,
                          editFrequency: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.frequency:null,
                          editFields: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.purchasedFields:null,
                          editCustomLeadNumbers: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.customLeadNumbers:null,
                          editEmailAddressesDelimited: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.emailAddressesDelimited:null,
                          selectedLeadsLength: _ctx.autoLeadsAlreadyPresent?_ctx.selectedAutoLeads.customLeadNumbers:null,
                          onCloseAutoDataDeliveryModel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeAutoDataDeliveryModel()))
                        }, null, 8, ["isEdit", "editType", "editStatus", "editFrequency", "editFields", "editCustomLeadNumbers", "editEmailAddressesDelimited", "selectedLeadsLength"]))
                      : _createCommentVNode("", true),
                    (_ctx.toggleActiveAutoDataSummaryModel)
                      ? (_openBlock(), _createBlock(_component_ActiveAutoDataSummary, {
                          key: 2,
                          activeAutoData: _ctx.selectedAutoLeads,
                          projectName: _ctx.siteName,
                          siteId: _ctx.siteId,
                          onClose: _ctx.onCloseActiveAutoDataSummary,
                          onCloseAndEditAutoDataLead: _ctx.onCloseActiveAutoDataSummaryAndEditAutoDataLead
                        }, null, 8, ["activeAutoData", "projectName", "siteId", "onClose", "onCloseAndEditAutoDataLead"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    (_ctx.response)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_58, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_59, [
                                (_ctx.response.pageInfo.totalResults)
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: _ctx.isCheckAll || _ctx.isSelectAll,
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onCheckAll($event.target.checked))),
                                      disabled: _ctx.isSelectAll,
                                      class: "ma--right-1"
                                    }, null, 8, _hoisted_60))
                                  : _createCommentVNode("", true),
                                _createTextVNode("Select All ")
                              ]),
                              _hoisted_61,
                              _hoisted_62,
                              _hoisted_63
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.data, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_64, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedLeads) = $event)),
                                    checked: _ctx.isSelectAll,
                                    type: "checkbox",
                                    value: item.id
                                  }, null, 8, _hoisted_65), [
                                    [_vModelCheckbox, _ctx.selectedLeads]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.$filters.dateDisplay(item.createdTime)), 1),
                                _createElementVNode("td", _hoisted_67, _toDisplayString(item.state), 1),
                                _createElementVNode("td", _hoisted_68, _toDisplayString(item.zipcode), 1)
                              ]))
                            }), 128)),
                            (_ctx.response.data.length == 0)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_69, _hoisted_71))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.response.pageInfo.totalResults)
                      ? (_openBlock(), _createBlock(_component_Pagination, {
                          key: 1,
                          totalResults: _ctx.response.pageInfo.totalResults,
                          totalPages: _ctx.response.pageInfo.totalPages,
                          showPage: _ctx.response.data.length,
                          page: _ctx.request.page,
                          onApplyPagination: _ctx.controlWithPagination
                        }, null, 8, ["totalResults", "totalPages", "showPage", "page", "onApplyPagination"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}